import { UILoadingPropsType } from "@/types/shared/uiComponents";
import { createContext, useContext } from "react";

export const InitialLoadingContext = createContext<boolean>(false);
export function useInitialLoadingContext() {
  return useContext(InitialLoadingContext);
}

export function useUILoadingContext(uiLoadingPropsFromComponent: UILoadingPropsType) {
  const { loading: initialLoadingFromProps } = uiLoadingPropsFromComponent;

  const initialLoadingFromContext = useInitialLoadingContext();

  return {
    initialLoading: initialLoadingFromProps || initialLoadingFromContext,
  };
}
